// Page-level keyboard shortcuts that click elements matching CSS selectors.
//
// Usage:
//   <div data-controller="keyboard-shortcut"
//        data-keyboard-shortcut-keys-value='{"a":"[data-allow]","ArrowLeft":"[data-prev]"}'>
//     <button data-allow>Allow</button>
//     <a data-prev href="...">Previous</a>
//   </div>
//
// Maps key names (KeyboardEvent.key) to CSS selectors. When a key is pressed,
// the first matching element within the controller's scope is clicked.
// Ignores keypresses when focus is in form inputs.

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { keys: { type: Object, default: {} } };

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown(event) {
    if (
      event.target.matches("input, textarea, select") ||
      event.metaKey ||
      event.ctrlKey
    )
      return;

    const selector = this.keysValue[event.key];
    if (!selector) return;

    const el = this.element.querySelector(selector);
    if (!el) return;

    event.preventDefault();
    el.click();
  }
}
